import { HttpEvent, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, from } from "rxjs";
import { mergeMap, toArray } from "rxjs/operators";

import { QueryStrings } from "src/app/models/emitter-events.models";
import { Inspection } from "src/app/models/inspection.model";
import { LocaleService } from "src/app/services/locale/locale.service";
import { RequestService } from "src/app/services/request/request.service";
import { LoggerService } from "./../../../services/logger.service";

@Injectable({
	providedIn: "root",
})
export class InspectionHistoryService {
	private httpOptions = {
		observe: "response",
	};

	constructor(
		public logger: LoggerService,
		public requestService: RequestService,
		private localeService: LocaleService,
	) {}

  public getInspectionList(
    companyId: string,
    endpoint: string,
    queryStrings: QueryStrings,
  ): Observable<HttpEvent<Inspection[]>> {
    const { sort, sortDir, page, perPage, ...remainingQueryStrings } = queryStrings;
    const url = `${endpoint}/inspections?page=${page}&perPage=${perPage}&sort=${sort}&sortDir=${sortDir}`;
    const data = { companyId, ...remainingQueryStrings, notFailed: true };

    this.logger.log('Sending inspections request...');
    return this.requestService.post<HttpEvent<Inspection[]>>({ url, data, httpOptions: this.httpOptions });
  }

  public getSingleInspections(inspectionIds: string[], companyId: string, endpoint: string) {
    // Maximum number of request being subscribed to concurrently.
    const maxRequestSize = 100;
    return from(inspectionIds).pipe(
      mergeMap((inspectionId: string) => {
        return this.requestService.get<HttpResponse<Inspection>>({
          url: `${endpoint}/inspections/${inspectionId}?companyId=${companyId}`,
          httpOptions: this.httpOptions,
        });
      }, maxRequestSize),
      toArray(),
    );
  }

  public exportAllInspections(
    companyId: string,
    endpoint: string,
    queryStrings: QueryStrings,
  ): Observable<Blob> {
    const { sort, sortDir, page, perPage, ...remainingQueryStrings } = queryStrings;
		// The CSV is rendered server-side, so the unit system has to travel with the request.
		// `useMetricUnit` is a query param (not a body field) and defaults to false (imperial).
		const useMetricUnit = this.localeService.usesMetricSystem();
		const url = `${endpoint}/inspections/csv?sort=${sort}&sortDir=${sortDir}&useMetricUnit=${useMetricUnit}`;
    const data = { companyId, ...remainingQueryStrings, notFailed: true };

    return this.requestService.post({ url, data, httpOptions: { responseType: "blob" } });
  }
}
